/** Timers — create view (delegates to the shared TimerForm). */
import { TimerForm } from "./_TimerForm";

export function TimerCreate() {
  return <TimerForm action="create" />;
}

export default TimerCreate;
